// attach global handlers for ajax events
$(document).on('ajaxComplete', ht.globalAjaxComplete);
$(document).on('ajaxError', ht.globalAjaxError);
